import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-info-fact',
    templateUrl: './info-fact.component.html',
    styleUrls: ['./info-fact.component.css'],
    standalone: false
})
export class InfoFactComponent implements OnInit {

  @Input() chantier;
  @Input() edit: Boolean;
  @Input() hidetitle: Boolean;
  resultCpVille: any[] = [];
  dataAdresseBAK: any[] = [];
  status: { iscp: boolean, isville: boolean } = { iscp: false, isville: false };
  adresseAutoBAK: Boolean = false;

  constructor(public common: CommonService) { }

  ngOnInit() {
    const societe = this.common.local.getObject('paramSociete') || {};
    const site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = site['rechercheAdresse'] && (site['serviceAdresse'] &&
      site['serviceAdresse'].typeServiceAdresse &&
      site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    this.adresseAutoBAK = (societe['rechercheAdresse'] && (societe['serviceAdresse'] &&
      societe['serviceAdresse'].typeServiceAdresse &&
      societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;
  }

  searchCPVille(event, val?) {
    this.resultCpVille = [];
    const param = {
      'servlet': val ? 'DBCodePostalVilleGetListParCP' : 'DBCodePostalVilleGetListParVille',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': event
    };

    this.common.post('', { param: param }).then(datas => {
      val ? $('#cp').trigger('click') : $('#ville').trigger('click');
      this.resultCpVille = datas.data;
      if (!this.resultCpVille.length) {
        val ? this.change(false, val) : this.change(false);
      } else {
        if (event.length >= 2) {
          if (val) {
            if (!this.status.iscp) {
              this.toggleDropdown(val);
            }
          } else {
            if (!this.status.isville) {
              this.toggleDropdown();
            }
          }
        }
      }
    });
  }

  selectAdresse(item) {
    this.chantier.CPChantierFact = item.codePostal;
    this.chantier.villeChantierFact = item.ville;
    this.status.iscp = false;
    this.status.isville = false;
  }

  toggleDropdown(val?): void {
    val ? this.status.iscp = !this.status.iscp : this.status.isville = !this.status.isville;
  }

  change(value: boolean, val?): void {
    val ? this.status.iscp = value : this.status.isville = value;
  }

  searchAdresseBAK(event) {
    this.dataAdresseBAK = [];
    const param = {
      'servlet': 'DBGestionAdresseRecherche',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CHAINE_RECHERCHE': event
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');;
      if (this.common.verifySession(datas)) {
        this.dataAdresseBAK = datas.data;
        this.dataAdresseBAK.forEach(elt => {
          elt.id = elt.clefBAK;
          elt.libelleObjetEntite = elt.label;
        });
      }
    });
  }

  setValueAdresseBAK(value, name?) {
    if(value && (!value.numero || (value.numero && value.numero === '0'))) {
        value.numero = '';
    }
          
    this.chantier['adresse1ChantierFact'] = `${value.numero || ''} ${value.suffixe || ''}`;
    this.chantier['adresse2ChantierFact'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
    this.chantier['adresse3ChantierFact'] = '';
    this.chantier['CPChantierFact'] = value.postcode;
    this.chantier['villeChantierFact'] = value.city;
  }
}
